import { Root } from './root';

export const Planning = {
    Root
};
